var types = {
  PERSONAL: 'PERSONAL',
  BUSINESS: 'BUSINESS',
  HELP_CENTRE: 'HELP_CENTRE'
};
export default types;